import React from "react";
import { LANGUAGES, getLang, setLang } from "../i18n";

/** SV | EN toggle. Switching reloads the page in the chosen language. */
export default function LanguageSwitch({ dark = false }) {
  const current = getLang();
  return (
    <div
      role="group"
      aria-label="Language / Språk"
      style={{
        display: "inline-flex",
        border: `1px solid ${dark ? "rgba(255,255,255,0.4)" : "#d0d5dd"}`,
        borderRadius: 8,
        overflow: "hidden",
        flexShrink: 0,
      }}
    >
      {LANGUAGES.map((l) => {
        const active = l.code === current;
        return (
          <button
            key={l.code}
            type="button"
            title={l.label}
            aria-pressed={active}
            onClick={() => setLang(l.code)}
            style={{
              border: 0,
              padding: "4px 10px",
              fontSize: 12,
              fontWeight: 600,
              cursor: active ? "default" : "pointer",
              background: active ? "var(--primary-color)" : "transparent",
              color: active ? "#fff" : dark ? "#fff" : "#344054",
            }}
          >
            {l.code.toUpperCase()}
          </button>
        );
      })}
    </div>
  );
}
